<template>
  <v-menu bottom :nudge-width="70" :close-on-content-click="false" offset-y data-qa="notificationlist-menu-0fpw0h">
    <template v-slot:activator="{ on }">
      <v-btn icon class="ma-2" v-on="on" data-qa="notificationlist-btn-z1a84">
        <v-icon :color="onSurfaceMedium" class="material-symbols-outlined" data-qa="notificationlist-icon-w3y4w8">notifications</v-icon>
      </v-btn>
    </template>
      <v-card max-width="300" data-qa="notificationlist-card-gqb0sf">
      <v-list two-line data-qa="notificationlist-list-vpdqx">
        <v-list-item-group multiple active-class="pink--text" data-qa="notificationlist-list-item-group-uqce0e">
          <template v-for="(item, index) in notifications">
            <v-list-item v-if="item.title" :key="index" :data-qa="`notificationlist-list-item-qravae-${index}`">
              <template v-slot:default="{ }">
                <v-list-item-content :data-qa="`notificationlist-list-item-content-8464u-${index}`">
                  <v-list-item-title :data-qa="`notificationlist-list-item-title-5tvoyi-${index}`">{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle class="text--primary" :data-qa="`notificationlist-list-item-subtitle-ersyb-${index}`">{{ item.headline }}</v-list-item-subtitle>
                  <v-list-item-subtitle :data-qa="`notificationlist-list-item-subtitle-o3uqhf-${index}`">{{ item.subtitle }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action :data-qa="`notificationlist-list-item-action-wmlmmj-${index}`">
                  <v-list-item-action-text :data-qa="`notificationlist-list-item-action-text-ty1p0g-${index}`">{{ item.action }}</v-list-item-action-text>
                </v-list-item-action>
              </template>
            </v-list-item>
            <v-divider v-if="index + 1 < item.length" :key="index" :data-qa="`notificationlist-divider-t8hw6-${index}`"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'NotificationList',
  data () {
    return {
      showUserNotification: false,
      notifications: [
        {
          action: '15 min',
          headline: 'Bank Admin',
          title: 'KYC verification is successful',
          subtitle: 'An email is sent with details'
        },
        {
          action: '2 hr',
          headline: 'Relationship Manager',
          title: 'New account activated for Savings',
          subtitle: 'An email is sent with details'
        },
        {
          action: '4 hr',
          headline: 'Bank Admin',
          title: 'Address details updated successfully',
          subtitle: 'An email is sent with details'
        },
        {
          action: '6 hr',
          headline: 'Bank Admin',
          title: 'Joint account application processed',
          subtitle: 'An email is sent with details'
        }
      ]
    }
  }
}
</script>
